import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
import { disableUser, enableUser, getAccountInfo } from '@/clients/admin';
export async function fetch_sub_users({ commit }, { accountId, search, roles, statuses }) {
    try {
        const payload = {
            search,
            roles,
            statuses,
        };
        const response = await Vue.axios.post(`${getApiUrl('v4')}/admin/account/${accountId}/users`, payload);
        commit('set_sub_users', response.data);
    }
    catch (e) {
        console.log(e);
    }
}
export async function reset_sub_users({ commit }) {
    commit('set_sub_users', []);
    commit('set_selected_sub_user', null);
}
export function select_sub_user({ commit }, { userId }) {
    commit('set_selected_sub_user', userId);
}
export function select_account({ commit }, { accountId }) {
    commit('set_selected_account', accountId);
}
export function select_user({ commit }, { userId }) {
    commit('set_selected_user', userId);
}
export async function fetch_account_info({ commit }, { accountId }) {
    try {
        const response = await getAccountInfo(accountId);
        const account = response.data;
        commit('set_selected_account_info', account);
    }
    catch (e) {
        console.log(e);
    }
}
export async function update_sub_users({ commit }, data) {
    try {
        const params = {
            name: data.name,
            email: data.email,
            role: data.role,
            whatsapp_number: data.whatsappNumber,
        };
        const base_api = getApiUrl('v4');
        const response = await Vue.axios.patch(`${base_api}/admin/user/${data.id}`, params);
        const updatedUser = {
            id: response.data.id,
            name: response.data.name,
            email: response.data.email,
            whatsapp: response.data.whatsapp_number,
            role: response.data.role,
            active: response.data.active,
            created_at: response.data.created_at,
            updated_at: response.data.updated_at,
        };
        commit('set_sub_user', updatedUser);
    }
    catch (e) {
        console.log(e);
    }
}
export async function active_user({ commit }, id) {
    try {
        const response = await enableUser(id);
        const { email } = response.data.data.attributes;
        commit('set_sub_user', { id, active: true, email });
    }
    catch (e) {
        console.log(e);
    }
}
export async function inactive_user({ commit }, id) {
    try {
        const response = await disableUser(id);
        const { email } = response.data.data.attributes;
        commit('set_sub_user', { id, active: false, email });
    }
    catch (e) {
        console.log(e);
    }
}
export async function update_credit_consumption_detail({ commit }, detail) {
    commit('set_credit_consumption_detail', detail);
}
export async function update_right_tab_of_modal({ commit }, tab) {
    commit('set_right_tab_of_modal', tab);
}
export async function update_left_tab_of_modal({ commit }, tab) {
    commit('set_left_tab_of_modal', tab);
}
